// eslint-disable-next-line import/prefer-default-export
export const VARIANT = {
  FILLED: 'filled',
  LINK: 'link',
  OUTLINED: 'outlined',
  TEXT: 'text',
}
